export default "https://frontendwarfare.com/api/v1/iq-test";
